import { Typography, Box, useTheme, TextField, Divider, Autocomplete, Button, Grid, Dialog, Tooltip, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CallAlertBar from "../../Layout/Alertbar";
import { tokens } from "../../theme/theme";
import { callApi } from "../../utils/apiClient";
import { API_ENDPOINTS } from "../../config/api/apiCall";
import useMaterialCategory from "../../hooks/useMaterialCategory";
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import DeleteForeverIcon from '@mui/icons-material/HighlightOff';
const AddCategory = ({ onClose, handleBackWinderMachineEntry, open }) => {


    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [result, setresult] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedCategoryCode, setSelectedCategoryCode] = useState(null);
    //message are 
    const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
    const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
    const [parentRollMessageValue, setParentRollMessageValue] = useState('');
    const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');
    const handleDeleteCategory = (id) => {
        // show confirm dialog maybe?
        if (window.confirm("Are you sure you want to delete this category?")) {
            // Do your delete logic here
            // Could be API call or local state update
            console.log("Deleting category ID:", id);

            let requestBody = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
                p_id_category: id,
            };

            callApi(API_ENDPOINTS.CATEGORY_DELETE, 'POST', { 'Content-Type': 'application/json' }, requestBody)
                .then(data => {
                    // Update state with fetched data

                    if (data[0].result_value == 0) {
                        // Show a notification when the PDF is downloaded successfully
                        toast.success('Category deleted Successfully.', { position: toast.POSITION.BOTTOM_CENTER });
                        loadMaterialCategoryByID(0);  // or whatever logic you use here               

                    }
                    else if (data[0].result_value == 1) {
                        // Show a notification when the PDF is downloaded successfully
                        toast.error('Category has been added to materials. Please remove it from materials.', { position: toast.POSITION.BOTTOM_CENTER });
                    }

                })
                .catch(error => {
                    alert(error.message);
                });
        }
    };

    const CategoryColumns = [
        {
            field: 'sno',
            headerName: 'S.No',
            // width: 120,
            sortable: false,
            filterable: false,
            renderCell: (params) => params.api.getAllRowIds().indexOf(params.id) + 1,
        },
        {
            field: "category_code",
            headerName: "Category Code",
            flex: 1,
            cellClassName: "name-column--cell"

        },
        {
            field: "description",
            headerName: "Category Name",
            flex: 1,
            cellClassName: "name-column--cell"

        },
        {
            field: "actions",
            headerName: "Actions",
            width: 100,
            sortable: false,
            filterable: false,
            renderCell: (params) => (
                // <IconButton
                //     color="error"

                //     onClick={() => handleDeleteCategory(params.row.id_material_category)}
                // >
                //     <DeleteIcon style={{fontSize:'22px'}}/>
                // </IconButton>

                <Tooltip title="Delete Material Category">
                    <IconButton
                        color="error"

                        onClick={() => handleDeleteCategory(params.row.id_material_category)}
                    >
                        <DeleteForeverIcon style={{ fontSize: '22px' }} />
                    </IconButton></Tooltip>
            )
        }
    ];

    const { materialCategory, selectedCategoryID, setSelectedCategoryID, loadMaterialCategoryByID } = useMaterialCategory(0);



    const handleSaveOperator = () => {
        setParentRollMsgOpen(false);
        // validation 
        let isValid = true;
        let validation_msg = '';
        if (selectedCategoryCode === '' || selectedCategoryCode == null) {
            validation_msg += 'Please Enter the Category Code.\n';
            isValid = false;
        }

        if (selectedCategory === '' || selectedCategory == null) {
            validation_msg += 'Please Enter the Category Name.\n';
            isValid = false;
        }

        if (isValid) {
            const SaveData = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
                p_category: selectedCategory,
                p_category_code: selectedCategoryCode,
            }

            callApi(API_ENDPOINTS.CATEGORY_CRUD, 'POST', { 'Content-Type': 'application/json' }, SaveData)
                .then(data => {
                    if (data && data.length > 0) {
                        setresult(data[0]);

                        if (data[0].result_value == 0) {
                            // Show a notification when the PDF is downloaded successfully
                            setParentRollSeverityvalue('info');
                            setParentRollMessageValue('New Category Added Successfully.');
                            setParentRollAlertTitleValue('Info');
                            setParentRollMsgOpen(true);


                            loadMaterialCategoryByID(0);  // or whatever logic you use here               

                        }
                        else if (data[0].result_value == 1) {

                            setParentRollSeverityvalue('warning');
                            setParentRollMessageValue('Category Code already exist.');
                            setParentRollAlertTitleValue('Validation');
                            setParentRollMsgOpen(true);
                        }
                    }
                })
                .catch(error => {
                    alert(error.message);
                });
        }
        else {
            setParentRollSeverityvalue('warning');
            setParentRollMessageValue(validation_msg);
            setParentRollAlertTitleValue('Validation');
            setParentRollMsgOpen(true);
        }
    };



    return (

        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
            PaperProps={{
                style: {
                    alignSelf: 'flex-start',
                    margin: '0 auto',
                    position: 'relative',
                    top: '0px',
                },
            }}
            BackdropProps={{
                style: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    paddingTop: '20px',
                    minHeight: '100vh',
                    background: 'rgba(0,0,0,0.5)',
                },
            }}
        >


            <DialogTitle style={{ backgroundColor: colors.primary[600], color: colors.primary }}>
                <Box display="flex" alignItems="center">
                    {/* <WarningRoundedIcon style={{ marginRight: 8, color: 'pink', fontSize: "32" }} /> Add icon with some margin */}
                    <Typography>Add Cateogry</Typography>
                </Box>

            </DialogTitle>
            <DialogContent style={{ backgroundColor: colors.primary[500], color: colors.primary }}>
                {/* Your modal content here */}


                <Box>
                    {/* <Header title="Add New Operator" subtitle="" callback={onClose} />
                        <Divider /> */}
                    {/* Message box detail */}
                    <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
                        setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
                        setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />


                    <Grid container spacing={2} sx={{ width: '100%', p: 0.5 }} >
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}  >


                            <Box
                                display="grid"
                                gridTemplateColumns={{
                                    xs: 'repeat(2, 1fr)',
                                    sm: 'repeat(2, 1fr)',
                                    md: 'repeat(3, 1fr)',
                                    lg: 'repeat(12, 1fr)',
                                    xl: 'repeat(12, 1fr)',
                                }}
                                gridAutoRows="10px"
                                gap={{ xs: '40px', sm: '40px', md: '40px', lg: '10px', xl: '5px' }}
                                marginTop={1}
                            >


                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 12',
                                        md: 'span 12',
                                        lg: 'span 3',
                                        xl: 'span 3',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"

                                >
                                    <Typography variant="h6"> Code <span style={{ color: 'red' }}>*</span> </Typography>
                                </Box>

                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 5',
                                        xl: 'span 5',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"

                                >
                                    {/* <TextField value={selectedCategoryCode} color="secondary" onChange={(e) => setSelectedCategoryCode(e.target.value)} sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderStyle: 'dot', } } }} fullWidth size="small" type="text" ></TextField> */}

                                    <TextField
                                        value={selectedCategoryCode}
                                        color="secondary"
                                        onChange={(e) => {
                                            const val = e.target.value.toUpperCase();
                                            if (val.length <= 10) {
                                                setSelectedCategoryCode(val);
                                            }
                                        }}

                                        inputProps={{ maxLength: 10 }}

                                        fullWidth
                                        size="small"
                                        type="text"
                                    />




                                </Box>



                            </Box>

                            <Box
                                display="grid"
                                gridTemplateColumns={{
                                    xs: 'repeat(2, 1fr)',
                                    sm: 'repeat(2, 1fr)',
                                    md: 'repeat(3, 1fr)',
                                    lg: 'repeat(12, 1fr)',
                                    xl: 'repeat(12, 1fr)',
                                }}
                                gridAutoRows="10px"
                                gap={{ xs: '40px', sm: '40px', md: '40px', lg: '10px', xl: '5px' }}
                                marginTop={5}
                            >


                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 3',
                                        xl: 'span 3',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"

                                >
                                    <Typography variant="h6"> Name <span style={{ color: 'red' }}>*</span> </Typography>
                                </Box>

                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 9',
                                        xl: 'span 9',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"

                                >
                                    <TextField value={selectedCategory} color="secondary"

                                        onChange={(e) => {
                                            const val = e.target.value.toUpperCase();

                                            setSelectedCategory(val);

                                        }}

                                        sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderStyle: 'dot', } } }} fullWidth size="small" type="text" >

                                    </TextField>





                                </Box>



                            </Box>


                            <Box marginTop={5}>
                                <Box display="flex" justifyContent="flex-end">
                                    <Button onClick={handleSaveOperator} size="small" variant="contained" color="secondary">
                                        Add
                                    </Button>
                                    {/* <Button size="small" sx={{ marginLeft: "10px" }} variant="contained" onClick={onClose} color="secondary">
                                        Cancel
                                    </Button> */}
                                </Box>
                            </Box>


                            {/* 
                                </CardContent>
                            </Card> */}

                            <Divider sx={{ marginTop: '20px' }} />


                            <Box marginTop={1}>
                                <Typography variant="h6" sx={{ marginTop: '10px', marginBottom: '10px' }}> Category List</Typography>

                                <Box

                                    gridColumn="span 9"
                                    gridRow={"span 2"}
                                    alignItems="center"
                                    justifyContent="center"

                                    height="51vh"
                                    sx={{

                                        "& .MuiCheckbox-root": {
                                            color: `${colors.greenAccent[200]} !important`,
                                        },
                                        "& .Muidropdown-root": {
                                            color: `${colors.greenAccent[200]} !important`,
                                        },

                                        borderLeft: "0", // Remove left border
                                        borderRight: "0", // Remove right border
                                    }}
                                >
                                    <DataGrid name="dgv-orderselection" getRowId={(row) => row.id_material_category} pageSize={5} columnHeaderHeight={35} rowHeight={40} rows={materialCategory} columns={CategoryColumns}


                                    />

                                </Box>
                            </Box>

                        </Grid>
                    </Grid>
                </Box>




            </DialogContent>
            <DialogActions style={{ backgroundColor: colors.primary[400] }}>



                <Button size='small' onClick={onClose} variant="contained" color="secondary" style={{ textTransform: 'none' }} >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};
export default AddCategory;